const IMAGE_TAG_PATTERN = /<img\b[^>]*>/ig
const SRC_PATTERN = /\bsrc="([^"]*)"/i
const DATA_SRC_PATTERN = /\bdata-src="([^"]*)"/i
const ALT_PATTERN = /\balt="([^"]*)"/i
const NUMERIC_PLACEHOLDER_PATTERN = /^\d+$/

function normalizeMomentContent(content) {
	if (!content) {
		return ''
	}

	return String(content).replace(IMAGE_TAG_PATTERN, imageTag => {
		const source = pickRenderableSource(imageTag)
		if (!source || NUMERIC_PLACEHOLDER_PATTERN.test(source)) {
			return ''
		}

		const altMatch = imageTag.match(ALT_PATTERN)
		const alt = altMatch ? altMatch[1] : ''
		return `<img src="${escapeAttribute(source)}" alt="${escapeAttribute(alt)}">`
	})
}

function pickRenderableSource(imageTag) {
	const sourceCandidates = [
		readAttribute(imageTag, SRC_PATTERN),
		readAttribute(imageTag, DATA_SRC_PATTERN)
	].filter(Boolean)

	return sourceCandidates.find(candidate => !NUMERIC_PLACEHOLDER_PATTERN.test(candidate)) || ''
}

function readAttribute(imageTag, pattern) {
	const match = imageTag.match(pattern)
	return match ? match[1].trim() : ''
}

function escapeAttribute(value) {
	return String(value)
		.replace(/&/g, '&amp;')
		.replace(/"/g, '&quot;')
}

module.exports = {
	normalizeMomentContent
}
